import { ChebiLink } from "../components/common/ChebiLink"
import { HMDBLink } from "../components/common/HMDBLink"
import { HMDBPLink } from "../components/common/HMDBPLink"
import { PDBLink } from "../components/common/PDBLink"
import { PubChemLink } from "../components/common/PubChemLink"
import { UniprotLink } from "../components/common/UniprotLink"
import { triggerPipeline } from "../components/common/triggerPipelineButton"
import { ProteinPredLink } from "../components/common/ProteinPredLink"

export const similarityHeaders = [
      {
    headerName: 'Compound Name',
    minWidth: 200,
    sortable: true,
    field: 'compound_name', 
  },
  {
    headerName: 'ID',
    minWidth: 120,
    sortable: true,
    field: 'chemblId',
  },
  {
    headerName: 'Similarity',
    minWidth: 50,
    sortable: true,
    field: 'similarity',
  },
  {
    headerName: 'Smiles',
    minWidth: 600,
    sortable: true,
    field: 'smiles',
  }

]

export const hmdbHeaders = [
  {
    headerName: 'Protein Accession',
    minWidth: 150,
    sortable: true,
    field: 'protein_accession',
    cellRenderer: HMDBPLink
  },
  {
    headerName: 'Protein Name',
    minWidth: 200,
    sortable: true,
    field: 'protein_name',
  },
  {
    headerName: 'UniprotId',
    minWidth: 120,
    sortable: true,
    field: 'uniprot_id',
    cellRenderer: UniprotLink
  },
  {
    headerName: 'Metabolite Accession',
    minWidth: 150,
    sortable: true,
    field: 'metabolite_accession',
    cellRenderer: HMDBLink
  },
  {
    headerName: 'Smiles',
    minWidth: 250,
    sortable: true,
    field: 'smiles',
  },
  {
    headerName: 'Smiles Name',
    minWidth: 120,
    sortable: true,
    field: 'smiles_name',
  },
  {
    headerName: 'Chebi',
    minWidth: 120,
    sortable: true,
    field: 'chebi',
    cellRenderer: ChebiLink
  },
  {
    headerName: 'Pubchem',
    minWidth: 120,
    sortable: true,
    field: 'pubchem',
    cellRenderer: PubChemLink
  },
  {
    headerName: 'Pipeline',
    minWidth: 150,
    sortable: false,
    field: 'smiles',
    cellRenderer: triggerPipeline
  }

]

export const targetPredictionHeaders = [
  {
  headerName: 'Compound Name',
  minWidth: 200,
  sortable: true,
  field: 'compound_name',
  },
  {
    headerName: 'Target',
    minWidth: 120,
    sortable: true,
    field: 'target_name',
  },
  {
    headerName: 'Drug Class',
    minWidth: 50,
    sortable: true,
    field: 'drug_class',
  },
  {
    headerName: 'Ligand',
    minWidth: 50,
    sortable: true,
    field: 'ligand_name',
  },
  {
    headerName: 'TargetPred Score',
    minWidth: 50,
    sortable: true,
    field: 'ligt_map_score',
  },
  {
    headerName: 'Ligand Similarity Score',
    minWidth: 50,
    sortable: true,
    field: 'ligand_similarity_score',
  },
  {
    headerName: 'Binding Similarity Score',
    minWidth: 50,
    sortable: true,
    field: 'binding_similarity_score',
  },
  {
    headerName: 'DTP Docking Score',
    minWidth: 50,
    sortable: true,
    field: 'docking_score',
  },
  {
    headerName: 'UNIPROT ID',
    minWidth: 50,
    sortable: true,
    field: 'uniprotid',
    cellRenderer: ProteinPredLink
  },
  {
    headerName: 'PDB',
    minWidth: 50,
    sortable: true,
    field: 'pdb',
    cellRenderer: PDBLink
  }

]

export const molDockHeaders = [
  {
    headerName: 'Ligand',
    minWidth: 120,
    sortable: true,
    field: 'ligand',
  },
  {
    headerName: 'Target',
    minWidth: 120,
    sortable: true,
    field: 'target',
    cellRenderer: PDBLink
  },
  {
    headerName: 'UNIPROT ID',
    minWidth: 50,
    sortable: true,
    field: 'uniprotid',
    cellRenderer: UniprotLink
  },
  {
    headerName: 'Docking Score',
    minWidth: 50,
    sortable: true,
    field: 'docking_score',
  }
]

export const admetHeaders = [
  {
    headerName: 'Parameter',
    minWidth: 120,
    sortable: true,
    field: 'parameter',
  },
  {
    headerName: 'Value',
    minWidth: 120,
    sortable: true,
    field: 'value',
  },
  {
    headerName: 'SI Unit',
    minWidth: 60,
    sortable: true,
    field: 'siunit',
  },
  {
    headerName: 'Standard Value or Range',
    minWidth: 60,
    sortable: true,
    field: 'stdvalue',
  },
  {
    headerName: 'Significance',
    minWidth: 120,
    sortable: true,
    field: 'significance',
  }
]
